/*
 * File: /src/services/groupServices.js
 * Created Date: Friday June 14th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 14th June 2019 9:55:39 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import {
  AD_BASE_WORKFLOW_PATH,
  AD_BASE_TRIGGER_CONFIG_PATH,
} from '../constants';

export default {
  /**
   *
   *
   * @returns
   */
  fetchWorkflows() {
    return authedAxios.get(AD_BASE_WORKFLOW_PATH);
  },

  /**
   * Fetch the workflows gallery
   *
   * @returns
   */
  fetchWorkflowsGallery() {
    return authedAxios.get(AD_BASE_WORKFLOW_PATH + 'gallery');
  },

  /**
   * Add a new Workflow
   *
   * @param {*} wfData
   * @returns
   */
  addWorkflow(wfData) {
    return authedAxios.post(AD_BASE_WORKFLOW_PATH, wfData);
  },

  /**
   * Fetches the Trigger Config File
   *
   * @returns
   */
  fetchTriggerConfig() {
    return authedAxios.get(AD_BASE_TRIGGER_CONFIG_PATH);
  },

  getAutomationById(id) {
    return authedAxios.get(AD_BASE_WORKFLOW_PATH + id);
  },

  deleteAutomation(id) {
    return authedAxios.delete(AD_BASE_WORKFLOW_PATH + id);
  },
  fetch(id) {
    return authedAxios.get(AD_BASE_WORKFLOW_PATH + id);
  },
  /**
   * Save new Automation
   *
   * @param {*} automation
   * @returns
   */
  save(automation) {
    if (automation.id) {
      return authedAxios.put(AD_BASE_WORKFLOW_PATH + automation.id, automation);
    }
    return authedAxios.post(AD_BASE_WORKFLOW_PATH, automation);
  },

  /**
   * Change Template Folder
   *
   * @param {*} id
   * @param {*} folderId
   * @returns
   */
  changeFolder(id, folderId) {
    return authedAxios.put(AD_BASE_WORKFLOW_PATH + id + '/folder', {
      folderId: folderId,
    });
  },

  processFuture(id) {
    return authedAxios.put(AD_BASE_WORKFLOW_PATH + id + '/future');
  },
};
